
<template>
    <v-data-table
        :headers="headers"
        :items="usuarios"
        locale="es-mx"
        hide-default-footer
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td>
                <menu-item
                  :items="menuItems"
                  :id="item._id"
                  @menuAction="menuAction"
                />
              </td> 
              <td>{{ item.codigo }}</td>
              <td>{{ item.nombreCompleto }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.role }}</td>
              <td>{{ item.correo }}</td>
              <td>{{ item.puesto }}</td>
              <td>{{ item.dependencia }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
</template>

<script>
import MenuItem from "../menus/MenuItem";


export default {
  name: 'tablaDatosUsuarios',
  props: ['headers','usuarios'],
    components: {
      MenuItem,
    },
    data: () => ({
      menuItems: [  
        //{text:'Ver perfil', action: 'verPerfil'},
        { text: "Modificar datos", action: "modificarDatos" },
        { text: "Restablecer contraseña", action: "resetearPass" },
      ],
      buscar: '',
    }),
    methods: {
      menuAction(action, id){ 
        this.$emit(action, id)
      },
    },
};


</script>

